import { CanadaOperationCost } from '../operation-cost'

export const QuebecOperationCost = {
  ...CanadaOperationCost,
} as const
